import React, { useContext, useState } from "react";
import { useRef } from "react";
import { ThemeContext } from "../../context";
import "./contact.css"
import emailjs from '@emailjs/browser';

const Contact = () => {
    const formRef = useRef();
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode; 
    const [done, setDone] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        subject: '',
        email: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    
    const validateField = (name, value) => {
        switch (name) {
            case 'username':
                return value.trim().length < 3;
            case 'email':
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return !emailRegex.test(value);
            case 'message':
                return value.trim().length < 10;
            default:
                return false;
        }
    };
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        
        const hasError = validateField(name, value);
        setErrors(prev => ({ ...prev, [name]: hasError }));
    };
    
    const isFormValid = () => {
        return formData.username.trim().length >= 3 &&
               /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) &&
               formData.message.trim().length >= 10;
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!isFormValid()) {
            return;
        }
        
        emailjs.sendForm('service_6ne8w9o', 'template_iyulkwr', formRef.current, 'Ktbv8ySoQFCO3oL3Q')
      .then((result) => {
          console.log(result.text);
          setDone(true);
          setFormData({ username: '', subject: '', email: '', message: '' });
          setErrors({});
      }, (error) => {
          console.log(error.text);
      });
    }

    return(
        <div className="c">
            <div className="c-bg"></div>
            <div className="c-wrapper">
                <div className="c-left">
                <h1 className="c-title">Let's discuss your project</h1>
                <div className="c-info">
                    <div className="c-info-item">
                        <img src={require("../../img/skype.png")} style={{width:30, height:30, marginRight:10,}} />
                         Pietrogar_2                        
                    </div>
                    {/* <div className="c-info-item">
                        Contact@gmail.com
                    </div>
                    <div className="c-info-item">
                    <img src={require("../../img/location.jpeg")} style={{width:30, height:30, marginRight:10,}} />
                        From Chile, South America.
                    </div> */}
                </div>
                </div>
                <div className="c-right">
                    <p className="c-desc">
                        <b>What's your project?</b> Contact me to build your app.
                    </p>
                    <form ref={formRef} onSubmit={handleSubmit}>
                        <input 
                            style={{
                                backgroundColor : darkMode && "#333",
                                color: darkMode && "#fff",
                                borderBottomColor: errors.username ? '#f44336' : 'black'
                            }} 
                            type="text" 
                            placeholder="Name *" 
                            name="username"
                            value={formData.username}
                            onChange={handleInputChange}
                        />
                        <input 
                            style={{
                                backgroundColor : darkMode && "#333",
                                color: darkMode && "#fff"
                            }} 
                            type="text" 
                            placeholder="Subject" 
                            name="subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                        />
                        <input 
                            style={{
                                backgroundColor : darkMode && "#333",
                                color: darkMode && "#fff",
                                borderBottomColor: errors.email ? '#f44336' : 'black'
                            }} 
                            type="text" 
                            placeholder="Email *" 
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        <textarea 
                            style={{
                                backgroundColor : darkMode && "#333",
                                color: darkMode && "#fff"
                            }} 
                            rows="5" 
                            placeholder="Message *" 
                            name="message"
                            value={formData.message}
                            onChange={handleInputChange}
                        />
                        <button disabled={!isFormValid()} style={{opacity: isFormValid() ? 1 : 0.6}}>Submit</button>
                        {done && 'Thank you for your message. Will be answered shortly.' }
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Contact;